(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-video-wrap]').forEach(wrap => {
      if (wrap.dataset.ready) return;
      wrap.dataset.ready = 'true';
      const video = wrap.querySelector('video');
      const button = wrap.querySelector('[data-video-toggle]');
      const preference = matchMedia('(prefers-reduced-motion: reduce)');
      let userPaused = false;
      const paint = () => {
        button.querySelector('[data-video-label]').textContent = video.paused ? button.dataset.play : button.dataset.pause;
        button.querySelector('[data-video-icon]').textContent = video.paused ? '▶' : 'Ⅱ';
        button.setAttribute('aria-label', video.paused ? button.dataset.play : button.dataset.pause);
      };
      const play = () => video.play().catch(paint);
      video.muted = true;
      if (!preference.matches) { video.autoplay = true; play(); }
      video.addEventListener('play', paint);
      video.addEventListener('pause', paint);
      video.addEventListener('error', () => { video.poster && video.load(); button.hidden = true; }, {once: true});
      button.addEventListener('click', () => { if (video.paused) { userPaused = false; play(); } else { userPaused = true; video.pause(); } });
      preference.addEventListener('change', () => { if (preference.matches) video.pause(); else if (!userPaused) play(); });
      document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); else if (!userPaused && !preference.matches) play(); });
      paint();
    });
    scope.querySelectorAll('[data-product-root]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const thumbs = root.querySelectorAll('[data-gallery-src]');
      const main = root.querySelector('.gallery-main');
      const chooseImage = button => {
        main.src = button.dataset.gallerySrc;
        main.removeAttribute('srcset');
        main.alt = button.dataset.galleryAlt;
        thumbs.forEach(t => t.setAttribute('aria-pressed', String(t === button)));
      };
      thumbs.forEach(button => button.addEventListener('click', () => chooseImage(button)));
      root.querySelectorAll('input[name^="preview-pack"]').forEach(input => input.addEventListener('change', () => { const target = input.value === 'double' ? thumbs[1] : thumbs[0]; if (target) chooseImage(target); }));
      const pageLink = root.querySelector('[data-product-page-link]');
      const setPageVariant = id => { if (!pageLink || !id) return; const url = new URL(pageLink.href); url.searchParams.set('variant', id); pageLink.href = url; };
      root.querySelectorAll('[data-home-variant]').forEach(input => input.addEventListener('change', () => { setPageVariant(input.value); const thumb = thumbs[Number(input.dataset.imageIndex)]; if (thumb) chooseImage(thumb); }));
      root.querySelectorAll('input[name^="preview-pack"]').forEach(input => input.addEventListener('change', () => setPageVariant(input.value === 'double' ? pageLink?.dataset.doubleVariant : pageLink?.dataset.singleVariant)));
      const form = root.querySelector('[data-furgo-product-form]');
      if (!form) return;
      const button = form.querySelector('[data-add-button]');
      const status = form.querySelector('[data-product-status]');
      const update = () => { const variant = form.querySelector('input[name="id"]:checked'); button.disabled = Boolean(form.dataset.busy) || !variant || variant.dataset.available !== 'true'; button.textContent = form.dataset.busy ? button.dataset.adding : (variant?.dataset.available === 'true' ? button.dataset.add : button.dataset.sold); setPageVariant(variant?.value); };
      form.addEventListener('change', update);
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (button.disabled || form.dataset.busy) return;
        form.dataset.busy = 'true';
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = button.dataset.adding;
        status.textContent = '';
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 15000);
        const base = window.Shopify?.routes?.root || '/';
        let safeError = status.dataset.error;
        try {
          const payload = new FormData(form);
          payload.set('sections', 'furgo-cart-drawer');
          payload.set('sections_url', location.pathname);
          const response = await fetch(base + 'cart/add.js', {method:'POST',body:payload,headers:{Accept:'application/json'},signal:controller.signal});
          const data = await response.json();
          if (!response.ok) { if (typeof data.description === 'string') safeError = data.description; throw new Error('Cart rejected'); }
          status.textContent = status.dataset.success;
          form.querySelector('[data-view-bag]').hidden = false;
          if (window.FurgoCart) window.FurgoCart.open({trigger:button,html:data.sections?.['furgo-cart-drawer'],added:true});
        } catch { status.textContent = safeError; form.querySelector('[data-view-bag]').hidden = false; }
        finally { clearTimeout(timeout); delete form.dataset.busy; button.removeAttribute('aria-busy'); update(); }
      });
      update();
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  const toggle = document.querySelector('.menu-toggle');
  const menu = document.querySelector('#FurgoMenu');
  if (toggle && menu) {
    const close = () => { toggle.setAttribute('aria-expanded', 'false'); menu.hidden = true; };
    toggle.addEventListener('click', () => { const expanded = toggle.getAttribute('aria-expanded') === 'true'; toggle.setAttribute('aria-expanded', String(!expanded)); menu.hidden = expanded; });
    menu.querySelectorAll('a').forEach(link => link.addEventListener('click', close));
    document.addEventListener('keydown', event => { if (event.key === 'Escape' && !menu.hidden) { close(); toggle.focus(); } });
    matchMedia('(min-width:761px)').addEventListener('change', event => { if (event.matches) close(); });
  }
  const openContact = () => { const contact = document.querySelector('#contact'); if (contact && (location.hash === '#contact' || location.hash === '#FurgoContact' || contact.querySelector('[role=status], .errors'))) contact.open = true; };
  addEventListener('hashchange', openContact);
  openContact();
})();

